import React from 'react';

import moment from 'moment';
import { Input, Select, Button } from 'antd/lib';

import { Form } from '@ant-design/compatible';

import { withApollo } from 'react-apollo';

const FormItem = Form.Item;
const Option = Select.Option;

class FormCrearOrganismo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      usuarios: [],
      confirmDirty: false,
      autoCompleteResult: [],
      requiredInputs: true,
    };

    // console.log('PORPS');
    // console.log(props);
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSubmit(values);
        // console.log('VALUES => ', values);
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  crearOpciones(user) {
    return (
      <Option key={user._id} value={user._id}>
        {user.nombre + ' ' + user.apellido}
      </Option>
    );
  }

  render() {
    moment.locale('en');
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">Organismo</h1>

        <Form onSubmit={this.handleSubmit} className="formularios">
          <FormItem {...formItemLayout} label={<span>Nombre</span>}>
            {getFieldDecorator('nombre', {
              rules: [
                {
                  required: this.state.requiredInputs,
                  message: 'Por favor, ingresar el nombre!',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem {...formItemLayout} label={<span>Telefono</span>}>
            {getFieldDecorator('telefono', {
              rules: [
                {
                  message: 'Por favor, ingresar el telefono!',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem {...formItemLayout} label={<span>Direccion</span>}>
            {getFieldDecorator('direccion', {
              rules: [
                {
                  required: this.state.requiredInputs,
                  message: 'Por favor, ingresar la direccion!',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem {...formItemLayout} label={<span>Ciudad</span>}>
            {getFieldDecorator('ciudad', {
              rules: [
                {
                  required: this.state.requiredInputs,
                  message: 'Por favor, ingresar la ciudad!',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem {...formItemLayout} label={<span>Circunscripción</span>}>
            {getFieldDecorator('circunscripcion', {
              rules: [
                {
                  required: this.state.requiredInputs,
                  message: 'Por favor, ingresar la circunscripcion!',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem {...formItemLayout} label={<span>Email</span>}>
            {getFieldDecorator('email', {
              rules: [
                {
                  required: this.state.requiredInputs,
                  message: 'Por favor, ingresar el email!',
                  whitespace: true,
                },
              ],
            })(<Input addonAfter="@jusneuquen.gov.ar" />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={<span>Codigo del Organismo</span>}
          >
            {getFieldDecorator('codigoOrganismo', {
              rules: [
                {
                  message: 'Por favor, ingresar el codigo del organismo!',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Confirmar
            </Button>
            <Button type="danger" onClick={this.props.onAnterior}>
              Cancelar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(withApollo(FormCrearOrganismo));
